module.exports = __webpack_public_path__ + "static/media/image (21).2cbfd51f.jpg";